import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IOurBrandsPage } from '../_prismic/brand';
import { PrismicService } from '../../_shared/_services/prismic.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { Subject, take } from 'rxjs';
import { IVendor, SEO } from '@app/_shared/_models';
import { VendorService } from '../../_shared/_services/vendor.service';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { BrandCardComponent } from '../../_shared/_components/brand-card/brand-card.component';

@Component({
    selector: 'app-our-brands',
    templateUrl: './our-brands.component.html',
    styleUrls: ['./our-brands.component.scss'],
    imports: [ImageComponent, BrandCardComponent]
})
export class OurBrandsComponent implements OnInit, OnDestroy {
  private readonly prismicService = inject(PrismicService);
  private readonly seoService = inject(SeoService);
  private readonly vendorService = inject(VendorService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/logos/main_logo.png',
    metaDescription: 'At My Pool Hut, we only sell the top quality brands in the pool and spa care industry.',
    metaTitle: 'Brands | My Pool Hut'
  };
  public ourBrandsPage!: IOurBrandsPage;
  public vendors = new Array<IVendor>();
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  ngOnInit(): void {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/brands');
    this.prismicService.getSingle('our_brands_landing_page')
      .pipe(take(1))
      .subscribe((res: any) => {
        this.ourBrandsPage = {
          hero_image: res.data.hero_image,
          title: res.data.main_title,
          subsection_title: res.data.subsection_title,
          subsection_image: res.data.subsection_image,
          brands_info_title: res.data.brands_info_title,
          brands_info_body: this.prismicService.getRichText(res.data.brands_info_body),
          subsection_body: this.prismicService.getRichText(res.data.subsection_body),
          hero_body: this.prismicService.getRichText(res.data.hero_body),
          brandsReel: this.prismicService.getBrandsFromSlice(res.data.body)
        }
      });

    this.vendors = this.vendorService.vendors;
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
